import Datadog from 'src/_shared/datadog';
import { DATADOG_CUSTOM_ACTIONS } from '../DatadogCustomActions';
import { BOOTSTRAP_CONTEXT, captureConnectionContext } from '../bootstrapContext';
import { extractErrorMessage } from 'src/helpers/error.helper';
import { BootstrapStep } from './bootstrapSteps.types';
import { BOOTSTRAP_STUCK_THRESHOLD_MS } from './bootstrapSteps.constants';

let lastStep: BootstrapStep | 'none' = 'none';
let stuckTimer: ReturnType<typeof setTimeout> | undefined;

const getElapsedMs = (): number => Math.round(performance.now());

const getVisibilityState = (): string => (typeof document === 'undefined' ? 'unknown' : document.visibilityState);

const reportBootstrapStuck = (): void => {
  stuckTimer = undefined;
  Datadog.logInfo(DATADOG_CUSTOM_ACTIONS.bootstrap_init_stuck, {
    ...BOOTSTRAP_CONTEXT,
    ...captureConnectionContext(),
    last_step: lastStep,
    elapsed_ms: getElapsedMs(),
    visibility_state: getVisibilityState(),
  });
};

export const markBootstrapStep = (step: BootstrapStep): void => {
  lastStep = step;
  Datadog.logInfo(DATADOG_CUSTOM_ACTIONS.bootstrap_step, {
    ...BOOTSTRAP_CONTEXT,
    step,
    elapsed_ms: getElapsedMs(),
  });
};

export const stopBootstrapWatchdog = (): void => {
  if (!stuckTimer) {
    return;
  }
  clearTimeout(stuckTimer);
  stuckTimer = undefined;
};

export const startBootstrapWatchdog = (): void => {
  stopBootstrapWatchdog();
  lastStep = 'none';
  stuckTimer = setTimeout(reportBootstrapStuck, BOOTSTRAP_STUCK_THRESHOLD_MS);
};

export const reportBootstrapFailure = (error: unknown): void => {
  stopBootstrapWatchdog();
  const errorMessage = extractErrorMessage(error);
  Datadog.logInfo(DATADOG_CUSTOM_ACTIONS.bootstrap_init_failed, {
    ...BOOTSTRAP_CONTEXT,
    ...captureConnectionContext(),
    last_step: lastStep,
    elapsed_ms: getElapsedMs(),
    error_message: errorMessage,
  });
  Datadog.logError('[initStore] FAILED', errorMessage);
};
